import { Icon } from "./icons";

export function ErrorIcon() {
	return (
		<span>
			<Icon
				name="XCircle"
				className="stroke-rose-500"
			/>
		</span>
	);
}
